module.exports = __webpack_public_path__ + "img/person-plus.4cfb60da.svg";